import {scmsService} from '../../services/site';
import {settings} from '../../common/setting';
import {user} from '../user';

export function browseAction() {
  const info = {
    tenantId: settings.tenantId,
    siteId: settings.siteId,
    globalUserId: user.globalUserId,
    openId: user.openId || '',
    channel_code: settings.channel_code,
    memberId: user.memberId,
    sess: user.session
  };
  scmsService.browse(info, ()=>{});
}